import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { PlayerGetRemoteGameHistory } from '../../source/appstates/playerstates/playerActions';
import moment from 'moment';
import { ProfileState } from '../../source/appstates/playerstates/playerState';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoginState } from '../../source/appstates/loginstates/loginState';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import * as appState from '../../source/appstates/appState'
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions'
import { NgxPaginationModule, PaginationControlsDirective } from 'ngx-pagination';
import { BrowserModule } from '@angular/platform-browser';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats, MatNativeDateModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MY_DATE_FORMATS } from '../../custom-date-format';
import { Meta, Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-casino-history',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule,TranslateModule, NgxPaginationModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule,
    MatDatepickerModule, MatNativeDateModule, FormsModule,],
  templateUrl: './casino-history.component.html',
  styleUrl: './casino-history.component.css',
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class CasinoHistoryComponent implements OnInit {


  private storeSub!: Subscription;
  gamehistory: any;
  profile: string = "";
  remoteGameHistoryErrorMessage: string = "";
  descriptiondata: string = "";
  totalrecords!: number;
  startDate!: Date;
  endDate!: Date;
  p: number = 1;
  todaydate: any;
  selectnum: number = 25;
  itemsPerPage: number = 25;
  totalItems!: number;
  selectnumber: number = -25;
  remotehistory: any[] = [];
  itemsperpagecount = [

    { num: 25 },
    { num: 40 },
    { num: 50 },
    { num: 99 },
  ];
  steddate: any;
  formNew!: FormGroup;
  form!: FormGroup;
  tableTrue: boolean = false;
  loginSub: Subscription;
  playerLoggedIn: boolean = false;
  remotehistoryList: any;
  loader: boolean = false;
  constructor(private router: Router, private translate:TranslateService,  private store: Store<appState.AppState>, private cdr: ChangeDetectorRef, private meta: Meta, private title: Title) {
    this.loginSub = this.store
      .select("loginState")
      .subscribe((loginState: LoginState) => {
        if (loginState.playerLoggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
        }
        if (!this.playerLoggedIn) {
          this.router.navigate(["/home"]);
        }
      });
  }
  ngOnInit() {
    window.scroll(0, 0);
    this.itemsPerPage = 25;
    this.p = 1;
 
    this.translate.get('CASINO_HISTORY_TITLE').subscribe(res => {
      this.title.setTitle(res);
      this.meta.updateTag({ property: 'og:title', content: res });
    });
    
    this.translate.get('CASINO_HISTORY_DESCRIPTION').subscribe(res => {
      this.meta.updateTag({ name: 'description', content: res });
      this.meta.updateTag({ property: 'og:description', content: res });
    });
    


    this.todaydate = moment(new Date()).format('YYYY-MM-DD');
    this.profile = sessionStorage.getItem('profile') || "";
    this.endDate = new Date();
    let today = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate() - 1);
    this.startDate = today;

    this.form = new FormGroup({
      "currency": new FormControl(sessionStorage.getItem('wallet')),
      "startDate": new FormControl(null, Validators.required),
      "endDate": new FormControl(null, Validators.required),
      "limit": new FormControl("10000000"),
      "index": new FormControl("0"),
    })

    this.formNew = new FormGroup({
      "currency": new FormControl(sessionStorage.getItem('wallet')),
      "startDate": new FormControl(null, Validators.required),
      "endDate": new FormControl(null, Validators.required),
      "limit": new FormControl("10000000"),
      "index": new FormControl("0"),
    })
    this.form.valueChanges.subscribe(x => {
      let yearsDiff = 0;
      var ToDate = new Date();
      var pastYear = ToDate.getFullYear() - yearsDiff;
      ToDate.setFullYear(pastYear);
      if (new Date(x.startDate).getTime() > ToDate.getTime() || new Date(x.startDate).getTime() > new Date(x.endDate).getTime() || new Date(x.endDate).getTime() > ToDate.getTime()) {
        this.steddate = true;
      } else {
        this.steddate = false;
      }
    });
    this.store.dispatch(new cashierActions.CashierGetBalanceStart());

    this.storeSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {
        this.tableTrue = false;
        this.loader = false;
        if (playerState.remotegameshistory) {
          if (playerState.remotegameshistory.success == true) {
            this.totalItems = playerState.remotegameshistory.total;
            if (playerState.remotegameshistory.values) {
              this.remotehistory = playerState.remotegameshistory.values;
              const historyList = [...this.remotehistory]
                .sort((a: any, b: any) => new Date(b.to).getTime() - new Date(a.to).getTime());

              this.remotehistoryList = historyList.map(data => ({
                ...data,
                from: data.from.replace(" ART", ""),
                to: data.to.replace(" ART", "")
              }));

              this.tableTrue = true;
              this.loader = false;

            } else {
              this.remotehistory = [];
            }
            if (playerState.remotegameshistory.description) {

              this.descriptiondata = playerState.remotegameshistory.description;
            }
            this.remoteGameHistoryErrorMessage = "";
          } else if (playerState.remotegameshistory.success == false) {
            this.remotehistory = [];
            if (playerState.remotegameshistory.description) {

              this.remoteGameHistoryErrorMessage = playerState.remotegameshistory.description;
            }
          }
          if (playerState.remotegameshistory.description) {
            if (playerState.remotegameshistory.description == 'Session expried') {
            }
          }
          if (playerState.remotegameshistory.values.length == 0) {
            this.tableTrue = false;
            this.remoteGameHistoryErrorMessage = 'THERE_IS_NO_HISTORY_FOR_THE_SELECTED_PERIOD'

          }
        }

        if (playerState.remotegameshistoryError) {
          this.remotehistory = [];
          this.remoteGameHistoryErrorMessage = playerState.remotegameshistoryError.message;
        }

      }
    )
    this.cdr.detectChanges()
  }

  onFormSubmit() {
    this.remoteGameHistoryErrorMessage = ''
    this.tableTrue = false;
    this.formNew.patchValue({
      startDate: moment(this.form.value.startDate).format('DD-MM-YYYY'),
      endDate: moment(this.form.value.endDate).format('DD-MM-YYYY')
    });
    this.store.dispatch(new cashierActions.CashierGetBalanceStart());
    this.store.dispatch(new PlayerGetRemoteGameHistory(this.formNew.value));
    this.loader = true;
  }

  onChange(data: any) {
    this.p = 1;
    this.itemsPerPage = +data.target.value;
  }

  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }
}
